import axios from 'axios'
import AuthToken from '@/auth/auth-token'

class DSD {
  constructor () {
    const base = axios.create({
      baseURL: process.env.BASE_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json'
      }
    })
    this.dsd = base
  }

  async getTemplate () {
    await AuthToken.setAuth(this.dsd)
    return this.dsd({
      url: '/dsd',
      method: 'GET',
      params: {}
    })
  }

  async uploadDSDFile(data) {
    console.log("UPLOADING FILE")
    await AuthToken.setAuth(this.dsd)
    return this.dsd({
      url: '/dsd',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      method: 'POST',
      data
    })
  }
}

export default new DSD()


// WEBPACK FOOTER //
// ./src/api/dsd.js